// extracted by mini-css-extract-plugin
export default {"delete":"PhotoDelete_delete__Qs9Wc"};